import { render, staticRenderFns } from "./ValidatorDetail.vue?vue&type=template&id=c91555f0&"
import script from "./ValidatorDetail.vue?vue&type=script&lang=js&"
export * from "./ValidatorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports